/*
Monotype Foundry Platform API
Version 1.0.0

Definition: FamilyIds

Properties:
  familyIds: array
*/

var FamilyIds = (function () {
  function validateFamilyIds (arg) {
    // Validate familyIds
    if (arg.familyIds && !(Array.isArray(arg.familyIds))) {
      throw new Error('FamilyIds.familyIds: Wrong type: Got \'' + (typeof arg.familyIds) + '\', but expected: \'array\'')
    }
  }
  function buildFamilyIds (arg) {
    var FamilyIds = arg
    // Complete familyIds
    // Expected Type: array
    FamilyIds.familyIds = FamilyIds.familyIds || []
    return FamilyIds
  }
  return {
    validate: validateFamilyIds,
    build: buildFamilyIds
  }
})()

module.exports = FamilyIds
